<!-- INDICE -->
<!-- <app-table-of-contents [sections]="sections" (selection)="scrollIntoView($event)"></app-table-of-contents> -->

<!-- INTRO -->
<span #dynamicElement id="intro"></span>
<app-app-section [sectionInfo]="introSection"></app-app-section>

<!-- NIE TIE -->
<span #dynamicElement id="nie"></span>
<app-card-paragraphs [cardInfo]="explicacionNieTie"></app-card-paragraphs>

<!-- REQUISITOS NIE -->
<span #dynamicElement id="requisitos"></span>
<!-- <h1 class="webapp-title">Requisitos para obtener el NIE</h1> -->
<app-smart-paragraph [text]="requisitosNie.longPar" [limit]="150" *ngIf="false"></app-smart-paragraph>
<app-app-section-accordion [sectionInfo]="requisitosNie" *ngIf="false"></app-app-section-accordion>

<!-- PASOS PARA EL NIE - FREE -->
<span #dynamicElement id="pasosnie"></span>
<h1 class="webapp-title">Pasos para obtener el NIE</h1>
<!-- En Madrid no hace falta sacar la cita de Asignación de NIE, directamente de huellas y listo -->
<p>El trámite de obtención del NIE se puede llevar a cabo mediante los siguientes métodos:</p>
<ul>
  <li>Presencialmente en España por parte del interesado, ante la Dirección General de Policía y de la Guardia Civil o directamente en la Oficina de Extranjeros o ante Comisarías de Policía del lugar de residencia en España.</li>
  <li>A través de representante en España.</li>
  <li>Presencialmente en las Representaciones Diplomáticas u Oficinas Consulares españolas ubicadas en el país de residencia del solicitante.</li>
</ul>

<!-- PASOS PARA OBTENER EL NIE - PREMIUM-->
<app-card-cta [cardInfo]="pasosParaNie" (callToAction)="buyProduct($event)" *ngIf="false"></app-card-cta>
<app-timeline-vertical [sectionInfo]="pasosParaNie" *ngIf="false"></app-timeline-vertical>

<!-- EMPADRONAMIENTO INFO -->
<!-- Photo by <a href="https://unsplash.com/@davidvives?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">David Vives</a> on <a href="https://unsplash.com/photos/white-and-brown-concrete-building-under-blue-sky-during-daytime-MVn-X6nfltU?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
<span #dynamicElement id="padron"></span>
<app-card-paragraphs [cardInfo]="empadronamiento"></app-card-paragraphs>

<!-- REQUISITOS PARA EL EMPADRONAMIENTO -->
<span #dynamicElement id="requisitospadron"></span>
<app-app-section-accordion [sectionInfo]="requisitosEmpadronamiento" *ngIf="false"></app-app-section-accordion>
<app-card-cta [cardInfo]="requisitosEmpadronamiento" (callToAction)="buyProduct($event)" *ngIf="false"></app-card-cta>

<!-- CONSEJOS IMPORTANTES -->
<span #dynamicElement id="tipsPadron"></span>
<app-section-post-list-img [sectionInfo]="tipsPadron" [rowsDisplayed]="2"></app-section-post-list-img>


<!-- City Selection Section -->
<!-- <div class="section city-selection">
  <h3>Select Your City</h3>
  <div class="btn-group btn-group-toggle" data-toggle="buttons">
    <label class="btn btn-primary shadow-sm" *ngFor="let city of cities" (click)="selectCity(city)">
      <input type="radio" name="options" id="option1" [checked]="selectedCity === city"> {{ city }}
    </label>
  </div>
</div> -->

<!-- NIE and TIE Section -->
<div class="section nie-tie" *ngIf="selectedCity">
  <h3>Steps to Get NIE and TIE in {{ selectedCity }}</h3>
  <ul>
    <li *ngFor="let step of nieTieSteps[selectedCity]">{{ step }}</li>
  </ul>
</div>

<!-- Empadronamiento Section -->
<div class="section empadronamiento" *ngIf="selectedCity">
  <h3>Steps to Empadronarse in {{ selectedCity }}</h3>
  <ul>
    <li *ngFor="let step of empadronamientoSteps[selectedCity]">{{ step }}</li>
  </ul>
</div>

  <!-- Photo by <a href="https://unsplash.com/@johnschno?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">John Schnobrich</a> on <a href="https://unsplash.com/photos/person-using-laptop-FlPc9_VocJ4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
  <!-- Photo by <a href="https://unsplash.com/@convertkit?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">ConvertKit</a> on <a href="https://unsplash.com/photos/white-and-red-labeled-box-htQznS-Rx7w?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
  <!-- Photo by <a href="https://unsplash.com/@jorgefdezsalas?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Jorge Fernández Salas</a> on <a href="https://unsplash.com/photos/people-walking-on-sidewalk-near-building-during-daytime-IxgEd_YfHcc?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
  <!-- Photo by <a href="https://unsplash.com/@theasophie?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Thea</a> on <a href="https://unsplash.com/photos/blue-and-white-2-signage-y3ZcWAgVphU?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
    <!-- <a href="/single/" class="link post-horizontal">
      <div class="infos">
        <div class="post-title">¿En cuánto tiempo me lo darán?</div>
        <p>¿Tendrás tu NIE al instante? Eso depende. En algunas oficinas y regiones te darán el número de identificación de inmediato. Sin embargo, en algunos otros, puede tardar de 4 a 5 días desde que se llevó a cabo el procedimiento de solicitud.</p>
      </div>
      <div class="post-image"><img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/74640e25-67ab-4bb9-9c01-f61d56308b00/public" alt=""></div>
  </a> -->


<!-- Cita Previa Issues Section -->
<div class="section cita-previa" *ngIf="false">
  <h2 class="webapp-title-secondary">Cita Previa Issues</h2>
  <p>Getting 'cita previa' can be challenging, especially in Madrid and Barcelona. Here are some tips and common issues:</p>
  <ul>
    <li>Be persistent and try booking appointments early in the morning.</li>
    <li>Use different devices and browsers to increase your chances.</li>
    <li>Consider seeking help from local agencies or our support team.</li>
  </ul>
</div>

<!-- Support Section -->
<div class="section support" *ngIf="false">
  <h2 class="webapp-title-secondary">Contact Support</h2>
  <p>If you have any doubts or need assistance with the migration process, please don't hesitate to contact our support team. We are here to help you every step of the way.</p>
  <button class="cta-button" (click)="contactSupport()">Contact Support</button>
</div>